import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Paper, CircularProgress } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useDispatch, useSelector } from "react-redux";
import { search } from "./../redux/actions/search";
import { useHistory } from "react-router-dom";

function Search({ handleToggle }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const users = useSelector(state => state.searchUsers);

    const [open, setOpen] = useState(false);
    const [searchedUsers, setSearchedUsers] = useState([]);

    useEffect(() => setSearchedUsers(users), [users]);

    return (
        <Paper style={{ marginBottom: "7px", padding: "9px" }}>
            <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                options={searchedUsers}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                getOptionLabel={option => option.name}
                renderOption={option => (
                    <React.Fragment>
                        <span
                            style={{ cursor: "pointer", width: "100%" }}
                            onClick={() => {
                                handleToggle();
                                history.push(`/${option._id}`);
                            }}
                        >
                            {option.name}
                        </span>
                    </React.Fragment>
                )}
                renderInput={params => (
                    <TextField
                        {...params}
                        onChange={e => dispatch(search(e.target.value))}
                        size="large"
                        label="Search by Name"
                        margin="none"
                        variant="outlined"
                        color="primary"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {(searchedUsers.length < 1 && open) && (
                                        <CircularProgress color="inherit" size={20} />
                                    )}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            )
                        }}
                    />
                )}
            />
        </Paper>
    );
}

export default Search;